import React from 'react'
import CareerDetails from '../CareerDetails'
import jobList from './positionList.json'

const WebGameDeveloper = () => {
  return <CareerDetails {...jobList[0]} />
}

export default WebGameDeveloper
